export default "__VITE_ASSET___KAQt3mn__"